import type { SVGProps } from 'react';
const DawnFlagCAF = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 22 16"
    {...props}
  >
    <rect width={22} height={16} fill="#fff" rx={2} />
    <mask
      id="dawn-flag-CAF_svg__a"
      width={22}
      height={16}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <rect width={22} height={16} fill="#fff" rx={2} />
    </mask>
    <g mask="url(#dawn-flag-CAF_svg__a)">
      <path fill="#19BFBF" d="M0 0h22v16H0z" />
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M6.313 4.433a.33.33 0 0 1 .092-.287l1.878-1.913a.33.33 0 0 1 .238-.1h1.224c.127 0 .243.073.3.187l.34.694a.33.33 0 0 0 .3.186h1.68c.126 0 .242.072.298.186l1.389 2.828a.33.33 0 0 0 .299.186h.704c.274 0 .43.31.268.531l-1.162 1.578a.3.3 0 0 0-.03.051l-.477.97a.3.3 0 0 0-.034.147v.912q0 .077-.035.147l-.49.997-.523 1.067-.432.88a.33.33 0 0 1-.3.187h-.632a.33.33 0 0 1-.3-.187l-.397-.81a.33.33 0 0 1-.034-.147V9.736a.33.33 0 0 0-.096-.233l-.373-.38a.33.33 0 0 1-.08-.13l-.424-1.297a.33.33 0 0 0-.317-.23H7.093a.33.33 0 0 1-.329-.279zM14.667 11c0-.184.15-.333.333-.333h.381c.184 0 .334.149.334.333v.656q0 .077-.034.147l-.402.817a.323.323 0 0 1-.612-.142z"
        clipRule="evenodd"
      />
    </g>
  </svg>
);
export default DawnFlagCAF;
